import { FunctionComponent } from "react";
import DropdownFilter from "../../../../components/DropdownFilter";
import { Selection } from "../../../search/@types";
import { MENU_STYLE } from "./const";
import { getActiveItemTitle } from "./utils";

export const addAllOption = (options: Selection[], allOptionLabel = "All") => [
  {
    value: "",
    label: allOptionLabel
  },
  ...(options ?? [])
];

type ExtractedFilesFileFormatFilterProps = {
  index: number;
  disabled?: boolean;
  active: string;
  onChange: (selectedValue: Selection) => void;
  menuItems: Selection[];
};
export const ExtractedFilesFileFormatFilter: FunctionComponent<
  ExtractedFilesFileFormatFilterProps
> = ({ index, disabled, active, onChange, menuItems }) => {
  const menuItemsWithAllOption = addAllOption(menuItems, "All Formats");
  const title = getActiveItemTitle(menuItemsWithAllOption, active);

  return (
    <DropdownFilter
      eventKey={index}
      title={<span>{title}</span>}
      field="fileFormat"
      activeFilter={active}
      menuItems={menuItemsWithAllOption}
      onFilterChange={onChange}
      disabled={disabled}
      styleVariant="primary"
      styles={{ menu: MENU_STYLE }}
    />
  );
};
